function LogoImage({title, logo_contents, logo_filetype, url = ''}) {

  if (logo_filetype == null || !logo_filetype.startsWith('image')) {
    return;
  }

  const logo_contents_url = `data:${logo_filetype};base64,${logo_contents}`;

  if (url === '') {
    return (
      <img src={logo_contents_url} alt={title} />
    );
  }

  return (
    <a href={url}>
      <img src={logo_contents_url} alt={title} />
    </a>
  );
}

export default LogoImage;
